import React from 'react'

export default (initialState) => {
  const [state, setState] = React.useState(initialState)
  const [runCallbackOnNextTick, setRunCallbackOnNextTick] = React.useState(false)
  const setStateCallback = React.useRef()

  const setStateWithCallback = (newState, callback) => {
    setState(newState)
    if(callback){
      if(typeof callback !== "function"){
        console.error("setState callback must be a function")
      }else{
        setStateCallback.current = callback
        setRunCallbackOnNextTick(true)
      }
    }
  }

  React.useEffect(() => {
    if(runCallbackOnNextTick){
      setRunCallbackOnNextTick(false)
      setStateCallback.current(state)
    }
  }, [runCallbackOnNextTick, state])

  return [state, setStateWithCallback]
}
